import { GET_WORKING_HOUR, LIST_BUSINESS_BLOCK_TIME, LIST_STAFF_BLOCK_TIME , GET_BUSINESS_TIME_OFF} from "./businessTypes";

export default {
  [GET_WORKING_HOUR](state, data) {
    state.workingHour = data;
  },

  [LIST_BUSINESS_BLOCK_TIME](state, data) {
    state.listBusinessBlockTime = data;
  },

  [LIST_STAFF_BLOCK_TIME](state, data) {
    state.listStaffBlockTime = data;
  },

  [GET_BUSINESS_TIME_OFF](state, data) {
    state.blockTime = data;
  },
}
